import {pageRoutes} from 'containers';
import React from 'react';

export const errorPagesConfigs = [
  {
    auth: ['user'],
    routes: [
      {
        path: pageRoutes.ERROR_404,
        component: React.lazy(() => import('./Error404')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: pageRoutes.ERROR_500,
        component: React.lazy(() => import('./Error500')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: pageRoutes.ERROR_403,
        component: React.lazy(() => import('./Error403')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: pageRoutes.ERROR_COMING_SOON,
        component: React.lazy(() => import('./ComingSoon')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: pageRoutes.ERROR_MAINTENANCE,
        component: React.lazy(() => import('./Maintenance')),
      },
    ],
  },
];
